import { gql } from "@apollo/client"

export const GET_MY_ORGANIZATION = gql`
  query getOrganizations {
    myOrganization {
      id
      name
      stats {
        members
        groups
        terminals
        activeDataPlans
        subOrganizations
      }
      billingAddress {
        address1
        address2
        country
        city
        zipCode
        vat
      }
      shippingAddress {
        address1
        address2
        country
        city
        zipCode
      }
      childOrganizations(first: 100, skip: 0) {
        edges {
          id
          name
        }
      }
    }
  }
`
